import React from 'react';
import { Button, CircularProgress } from '@material-ui/core';

const ActionButton = ({ classes, onClose, updateInProgress, updateEquipment, errorMessage }) => {
  const disabled = errorMessage || updateInProgress;
  return (
    <div className={classes.actionContainer}>
      <Button
        variant="outlined"
        color="primary"
        size="medium"
        onClick={onClose}
        classes={{ root: classes.actionButton }}
        id="closeButton">
        Close
      </Button>
      <Button
        variant="contained"
        color="primary"
        size="medium"
        type="submit"
        onClick={updateEquipment}
        disabled={disabled}
        classes={{
          root: classes.actionButton,
          disabled: classes.actionButtonDisabled
        }}>
        {updateInProgress ? (
          <CircularProgress size={16} classes={{ root: classes.circularProgress }} />
        ) : (
          'Update'
        )}
      </Button>
    </div>
  );
};
export default ActionButton;
